import React from 'react';
import {
  ElementImagePlaceholder,
  ElementInfo,
  ElementPrice,
  ElementSubInfo,
  LabelList,
  LabelListElement,
  ListElement,
  Text,
} from './CarSubListPlaceholder.styles';

// TODO: Design and update

export const CarSubListPlaceholder = () => (
  <ListElement>
    <ElementImagePlaceholder />
    <ElementInfo>
      <Text />
      <ElementSubInfo />
      <LabelList>
        {['1', '2'].map((number: string) => (
          <LabelListElement key={`placeholder-${number}-label-placeholder-${number}`} />
        ))}
      </LabelList>
      <ElementPrice />
    </ElementInfo>
  </ListElement>
);

export default CarSubListPlaceholder;
